import { Phone } from "lucide-react";
import { ContactMenu } from "./ContactMenu";
import { BRAND, PHONE_DISPLAY, TEL_HREF } from "../../lib/contact";

export const HouseMark = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true" className="shrink-0">
    <path pathLength="1" className="draw stroke-navy" d="M5 20 L20 7 L35 20 V35 H5 Z" fill="none" strokeWidth="3" />
    <path className="fill-coral" d="M20 30c-6-4-8-7-6-10 2-2 4-1 6 1 2-2 4-3 6-1 2 3 0 6-6 10z" />
  </svg>
);

export const SiteNav = () => (
  <nav data-testid="site-nav" className="sticky top-0 z-30 bg-ivory/95 backdrop-blur-md border-b border-navy/15">
    <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
      <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 min-w-0">
        <HouseMark />
        <span className="disp text-lg md:text-xl uppercase leading-tight">{BRAND}</span>
      </a>
      <a href={TEL_HREF} data-testid="nav-call-icon-mobile" aria-label={`Hívás: ${PHONE_DISPLAY}`} className="md:hidden flex h-12 w-12 shrink-0 items-center justify-center bg-coral text-coral-ink">
        <Phone className="h-6 w-6" />
      </a>
      <div className="hidden md:flex items-center gap-4 lg:gap-6 text-base">
        <a href="#segitseg" data-testid="nav-link-care" className="link-sweep hidden lg:inline">Segítség</a>
        <a href="#garanciak" data-testid="nav-link-legal" className="link-sweep hidden lg:inline">Garanciák</a>
        <ContactMenu
          testid="nav-messaging"
          triggerClassName="whitespace-nowrap border-2 border-navy px-4 py-2 font-semibold transition-colors hover:bg-navy hover:text-ivory"
        />
        <a
          href={TEL_HREF}
          data-testid="nav-call-button"
          className="bg-coral text-coral-ink px-5 py-2 font-semibold tab whitespace-nowrap transition-colors hover:bg-coral-deep"
        >
          Hívás: {PHONE_DISPLAY}
        </a>
      </div>
    </div>
  </nav>
);
